import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db, storage } from '../../../firebase';
import { doc, getDoc, deleteDoc } from 'firebase/firestore';
import { deleteObject, ref } from 'firebase/storage';
import { useLanguage } from '../../../context/LanguageContext.jsx';
import { TranslatedText } from '../../i18n/TranslatedText.jsx';
import './RejectedEvent.css';

const RejectedEventNotification = () => {
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const navigate = useNavigate();
  const { isEnglish } = useLanguage();

  useEffect(() => {
    const fetchEvent = async () => {
      const docRef = doc(db, 'events', eventId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setEvent(docSnap.data());
      } else {
        console.log('No such document!');
      }
    };

    fetchEvent();
  }, [eventId]);

  const handleDeleteEvent = async () => {
    try {
      // Best-effort cleanup of uploaded media to avoid leaving orphaned files in Storage.
      const mediaUrls = Array.isArray(event?.mediaUrls) ? event.mediaUrls : [];
      if (mediaUrls.length > 0) {
        await Promise.all(
          mediaUrls.map(async (url) => {
            try {
              await deleteObject(ref(storage, url));
            } catch (error) {
              console.error('Error deleting rejected event media:', error);
            }
          })
        );
      }

      if (
        event?.thumbnailUrl &&
        (!Array.isArray(event?.mediaUrls) || !event.mediaUrls.includes(event.thumbnailUrl))
      ) {
        try {
          await deleteObject(ref(storage, event.thumbnailUrl));
        } catch (error) {
          console.error('Error deleting rejected event thumbnail:', error);
        }
      }

      await deleteDoc(doc(db, 'events', eventId));
      navigate('/benim-etkinliklerim');
    } catch (error) {
      console.error('Error deleting event:', error);
    }
  };

  if (!event) return <div>{isEnglish ? 'Loading...' : 'Yükleniyor...'}</div>;

  return (
    <div className="rejected-event-container">
      <div className="rejected-event-header">
        <h2>{isEnglish ? 'Event Rejected' : 'Etkinlik Reddedildi'}</h2>
        <p>{isEnglish ? 'Your event submission was rejected.' : 'Onay isteği gönderdiğiniz etkinlik reddedilmiştir.'}</p>
      </div>
      <div className="rejected-event-details">
        <h3>
          <TranslatedText text={event.name} dynamic />
        </h3>
        <div className="rejected-event-info">
          <label>{isEnglish ? 'Event name:' : 'Etkinlik Adı:'}</label>
          <p>
            <TranslatedText text={event.name} dynamic />
          </p>
        </div>
        {event.rejectionReason && (
          <div className="rejection-reason">
            <h4>{isEnglish ? 'Reason:' : 'Red Sebebi:'}</h4>
            <p>
              <TranslatedText text={event.rejectionReason} dynamic />
            </p>
          </div>
        )}
      </div>
      <div className="action-buttons">
        <button className="action-button delete-button" onClick={handleDeleteEvent}>
          {isEnglish ? 'OK, delete event' : 'Tamam, Etkinliği Sil'}
        </button>
      </div>
    </div>
  );
};

export default RejectedEventNotification;
